import { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { IColumnDef, IExtendableDto } from "@ryde/shared";

import { BookingsPanelCalendar, BookingsPanelGrid } from "../panels";

interface IBookingsPanelSwitchRoutes {
  tableDefs: IColumnDef<IExtendableDto, unknown>[];
}

export const BookingsPanelSwitchRoutes: FC<IBookingsPanelSwitchRoutes> = ({
  tableDefs,
}) => {
  return (
    <Routes>
      <Route path="calendar/*" element={<BookingsPanelCalendar />} />
      <Route path="/*" element={<BookingsPanelGrid tableDefs={tableDefs} />} />
    </Routes>
  );
};
